import { useEffect, useRef } from "react";

// Run once per document, before React mounts. Route changes within this
// document still restore the current batch without making extra requests.
export function prepareStudyPage({ participantId, sessionId }) {
  for (const system of ["TEARS", "GERS"]) {
    const prefix = `recommendation-session-v4:${participantId}:${sessionId}:${system}`;
    try {
      const read = (field) => {
        try { return JSON.parse(sessionStorage.getItem(`${prefix}:${field}`)); }
        catch { return null; }
      };
      // Include pre-upgrade batches, empty responses, and interrupted requests.
      if (read("hasRequested") || read("results")?.length || read("notice")) {
        sessionStorage.setItem(`${prefix}:refreshPending`, "true");
      }
      for (const field of ["results", "previous", "comparison", "notice"]) {
        sessionStorage.removeItem(`${prefix}:${field}`);
      }
    } catch { /* Without storage, a new document already starts empty. */ }
  }
}

export function usePageRefresh(pending, ready, refresh) {
  const pendingOnMount = useRef(pending);
  const started = useRef(false);
  const callback = useRef(refresh);
  callback.current = refresh;
  useEffect(() => {
    if (!pendingOnMount.current || !pending || !ready || started.current) return;
    // React StrictMode may replay effects; send only one refresh request.
    started.current = true;
    callback.current();
  }, [pending, ready]);
}
